module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei2.svg";